import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsListComponent } from './forms-list/forms-list.component';
import { SellerSuccessComponent } from './seller-success/seller-success.component';
import {RouteUtils} from "../utils/route.utils";
import { PropertyDivisionFormPfComponent } from './property-division/property-division-pf/property-division-form-pf/property-division-form-pf.component';
import { PropertyDivisionStagePfComponent } from './property-division/property-division-pf/property-division-stage-pf/property-division-stage-pf.component';
import { PropertyDivisionSuccessPfComponent } from './property-division/property-division-pf/property-division-success-pf/property-division-success-pf.component';
import { PropertyDivisionFormPjComponent } from './property-division/property-division-pj/property-division-form-pj/property-division-form-pj.component';
import { PropertyDivisionStagePjComponent } from './property-division/property-division-pj/property-division-stage-pj/property-division-stage-pj.component';
import { PropertyDivisionSuccessPjComponent } from './property-division/property-division-pj/property-division-success-pj/property-division-success-pj.component';

const routes: Routes = [
  {
    path: RouteUtils.PAGES.FORM_LIST,
    component: FormsListComponent,
  },
  {
    path: 'seller-pf',
    loadChildren: () => import('./seller-pf/seller-pf.module').then(m => m.SellerPfModule),
  },
  {
    path: 'seller-pj',
    loadChildren: () => import('./seller-pj/seller-pj.module').then(m => m.SellerPjModule),
  },


  {
    path: 'property-division-pf',
    children: [
      { path: '', redirectTo: 'form', pathMatch: 'full' },
      { path: 'form', component: PropertyDivisionFormPfComponent },
      { path: 'stage', component: PropertyDivisionStagePfComponent },
      { path: 'success', component: PropertyDivisionSuccessPfComponent },
    ],
  },


  {
    path: 'property-division-pj',
    children: [
      { path: '', redirectTo: 'form', pathMatch: 'full' },
      { path: 'form', component: PropertyDivisionFormPjComponent },
      { path: 'stage', component: PropertyDivisionStagePjComponent },
      { path: 'success', component: PropertyDivisionSuccessPjComponent },
    ],
  },
  {
    path: 'seller-success',
    component: SellerSuccessComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [Location],
  exports: [RouterModule],
})
export class FormsRoutingModule {}
